module.exports = __webpack_public_path__ + "static/media/cover-asbestos-building-products.5d24aa6d.jpg";